import NepaliDatePicker from "../NepaliDatePicker/NepaliDatePicker";

import { ErrorMessage, Field } from "formik";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { replaceDecimal } from "../../utils/services";
import { AddableBank } from "../AddableBank/AddableBank";
import { DocumentContext } from "../BillPage/Document-Context";
import { PopupContext } from "../PopUp/Popup-Context";
import { ReciptValue, useReciptWrapper } from "./ReciptFormikWrapper";
import "./ReciptSlip.scss";
export interface bankDetailProps {
  id: number;
  name: string;
}

export interface CustomerData {
  name: string;
  pan: number | undefined;
  mobile_no: string;
  user_role_id: number | undefined;
  user_id: number | undefined;
  role_id: number | undefined;
  role: string;
  credit_total: any | undefined;
}
interface ReciptSlipProps {
  selectedUserObj?: CustomerData;
  setSelectedUserObj: React.Dispatch<
    React.SetStateAction<CustomerData | undefined>
  >;
  LedgerType: string;
  creatable: boolean;
}

export const ReciptSlip: React.FC<ReciptSlipProps> = ({
  setSelectedUserObj,
  selectedUserObj,
  LedgerType,
  creatable,
}) => {
  const [checkBox, setCheckBox] = useState(false);
  const [dateNew, setDateNew] = useState("");
  const { setFieldValue, values, handleSubmit, validateForm } =
    useReciptWrapper();
  const { isSubmitted } = useContext(DocumentContext);
  const { openModal, setPopupType } = useContext(PopupContext);

  useEffect(() => {
    if (
      (values.payType === "both" || values.payType === "cheque") &&
      Number(values.cash) + Number(values.bank[0].amount) >
        selectedUserObj?.credit_total
    ) {
      toast.warn(
        `Total amount can't be greater than  ${
          selectedUserObj?.credit_total ?? 0
        }`
      );
    }
  }, [values.bank[0].amount, values.cash]);

  const handleCash = (value: any) => {
    if (
      values.payType === "both" &&
      Number(value) + Number(values.bank[0].amount) >
        selectedUserObj?.credit_total
    ) {
      toast.warn(
        `Total amount can't be greater than  ${
          selectedUserObj?.credit_total ?? 0
        }`
      );
    } else if (value <= selectedUserObj?.credit_total) {
      setFieldValue("cash", replaceDecimal(value));
    } else {
      toast.warn(
        `Cash amount can't be greater than  ${
          selectedUserObj?.credit_total ?? 0
        }`
      );
    }
  };

  const handleCheck = () => {
    setCheckBox((checkBox) => !checkBox);
  };

  useEffect(() => {
    setFieldValue("date", dateNew);
  }, [dateNew, values.date]);

  useMemo(() => {
    setFieldValue("total_credit", selectedUserObj?.credit_total ?? 0);
  }, [selectedUserObj?.credit_total]);

  useEffect(() => {
    setFieldValue("bank", [
      {
        cheque_no: "",
        amount: 0,
        cheque_issue_date: "",
        bank_id: "",
      },
    ]);
  }, [isSubmitted]);

  useMemo(() => {
    const totalAmount =
      Number(values.cash ?? 0) + Number(values?.bank[0]?.amount ?? 0);
    setFieldValue("total", totalAmount);
    setFieldValue("user_role_id", selectedUserObj?.user_role_id);
  }, [selectedUserObj?.user_role_id, values?.bank, values.cash]);

  const PayTypeCheck = (value: "cash" | "cheque") => {
    if (values.payType === "both") {
      if (value === "cash") {
        setFieldValue("payType", "cheque");
        return;
      }
      if (value === "cheque") {
        setFieldValue("payType", "cash");
        return;
      }
    } else if (values.payType !== "" && values.payType === value) {
      setFieldValue("payType", "");
      return;
    } else if (values.payType !== "" && values.payType !== value) {
      setFieldValue("payType", "both");
      return;
    }
    setFieldValue("payType", value);
    return;
  };
  const handleClear = () => {
    setFieldValue("cash", 0);
    setPopupType("");
    setFieldValue("bank", [{
      cheque_no: "",
      amount: 0,
      cheque_issue_date: "",
      bank_id: "",
    }]);
    setFieldValue("payType", "cash");
    setFieldValue('bill_number', '');
  };

  return (
    <>
      <div className="row justify-content-between align-items-center">
        <div className="col-md-4 mb-2">
          <div className="form-group">
            <label htmlFor="date" className="input-label">
              Date:
            </label>
            <NepaliDatePicker
              // className="input-field"
              // defaultDate={true}
              currentDate={true}
              onDateSelect={(value: any) => {
                setDateNew(value);
              }}
            />

            <ErrorMessage name={`date`} component="div" className="error" />
          </div>
        </div>
        <div className="col-md-12">
          <div className="check-box-wrapper">
            <div className="check-box-section">
              <input
                className={
                  checkBox ? "checkbox onButton" : "checkbox offButton"
                }
                type="checkbox"
                onChange={() => {
                  PayTypeCheck("cash");
                  handleCheck();
                }}
                checked={values.payType === "cash" || values.payType === "both"}
              />

              <label className="check-label">Cash</label>
              <input
                type="checkbox"
                className="checkbox"
                onChange={() => {
                  PayTypeCheck("cheque");
                }}
                checked={
                  values.payType === "cheque" || values.payType === "both"
                }
              />
              <label className="check-label">Cheque</label>
            </div>
            <ErrorMessage className="error" component="div" name="payType" />
          </div>
        </div>
      </div>
      <div className="recipt-slip-page">
        {(values.payType === "cash" || values.payType === "both") && (
          <div className="cash-amt ">
            <p className="title">Cash</p>
            <label className="input-label">Amount</label>
            <Field
              className="input-field"
              pattern="[0-9]*"
              onFocus={(e: any) => {
                if (parseInt(e.target.value) === 0) {
                  e.target.value = "";
                }
              }}
              value={values.cash}
              onChange={(val: any) => {
                handleCash(val.target.value);
              }}
            />
            <ErrorMessage component="div" name="cash" className="error" />
          </div>
        )}
        {(values.payType === "cheque" || values.payType === "both") && (
          <div>
            <AddableBank
              LedgerType={LedgerType}
              creatableSelect={creatable}
              name="Pay by Cheque (Optional)"
              buttonName="Add Cheque"
              values={values as ReciptValue}
              setFieldValue={setFieldValue}
            />
          </div>
        )}
      </div>
      <div className="footer-space">
        <div className="d-end">
          <div>
            <button
              className="light-secondary mr-16"
              type="button"
              onClick={() => {
                handleClear();
              }}
            >
              Cancel
            </button>
          </div>
          <div>
            <button
              className="main-button"
              type="submit"
              onClick={() => {
                handleSubmit();
              }}
            >
              Add Receipt
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
